//import Link from "next/link";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { Fragment, useEffect, useState } from "react";
// import { useWindowSize } from "@/hooks/useIsMobile";
import siteInfo from "@/constants/siteInfo";
import GTMScript from "@/component/Ads/GTMScript";
const NoData = dynamic(() => import("@/component/NoData"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

const TopicCard = ({ item, isLCP = false }) => {
  return (
    <div className="flex flex-col overflow-hidden rounded-sm">
      <div className="relative justify-end items-end">
        <a href={item?.canonical_url}>
          <img
            className="  w-full object-fill relative"
            src={`${item?.profile_img}?size=180:180`}
            title={item?.title_short}
            alt={item?.title_short ? item?.title_short : siteInfo?.siteName}
            fetchpriority={isLCP ? "high" : "low"}
            loading={isLCP ? "eager" : "lazy"}
            role="button"
            style={{ zIndex: -1 }}
          />
        </a>
      </div>

      <div className="p-1 bg-gray-200 text-center h-14 flex justify-center items-center">
        <a href={item?.canonical_url}>
          <h3 className="font-bold line-clamp-2 hover:text-primary">
            {item?.title_short}
          </h3>
        </a>
      </div>
    </div>
  );
};

const TopicList = ({
  topicListData,
  allTopicsData,
  isMobileDevice = false,
}) => {
  const [activeTab, setActiveTab] = useState(-1);
  const keyBindings = {
    Category: ["NewsTak-topicpage"],
    Keywords: topicListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }
          // if (
          //   activeTab !== -1 &&
          //   topicListData &&
          //   topicListData?.content?.[activeTab]?.list?.length > 1
          // ) {
          //   googletag
          //     .defineSlot(
          //       "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
          //       [300, 250],
          //       "div-gpt-ad-1659434604998-0"
          //     )
          //     .addService(googletag.pubads());
          // }
          scrolled && document.getElementById("div-gpt-ad-1659435474737-0") && googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          !scrolled && googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          // rhs mtf
          scrolled && document.getElementById("div-gpt-ad-1751005897683-0") &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_MTF_300x250",
                [300, 250],
                "div-gpt-ad-1751005897683-0"
              )
              .addService(googletag.pubads());
          // rhs btf
          scrolled && document.getElementById("div-gpt-ad-1751005897683-1") &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1751005897683-1"
              )
              .addService(googletag.pubads());
          // if (
          //   activeTab !== -1 &&
          //   topicListData &&
          //   topicListData?.content?.[activeTab]?.list?.length > 1
          // ) {
          //   googletag
          //     .defineSlot(
          //       "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
          //       [728, 90],
          //       "div-gpt-ad-1707804176041-2"
          //     )
          //     .addService(googletag.pubads());
          // }

          scrolled &&
            document.getElementById("div-gpt-ad-1659425743360-0") &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 100);
  }, [scrolled]);

  function handleTabChange(tabIndex) {
    setActiveTab(tabIndex);
    setTimeout(function () {
      if (document.querySelectorAll('[id^="vdo_logo_parent"]')?.length === 0) {
        console.log("refresh vdo.ai ads");
        //* call vdo ai script again if ads not loaded
        (function (v, d, o, ai) {
          ai = d.createElement("script");
          ai.defer = true;
          ai.async = true;
          ai.src = v.location.protocol + o;
          d.head.appendChild(ai);
        })(window, document, "//a.vdo.ai/core/v-newstak/vdo.ai.js");
      }
    }, 200);
  }
  let adIndex = isMobileDevice ? 1 : 3;
  let excludeTopicCategory = ["Business", "Company", "Subject"];
  // const size = useWindowSize();
  return (
    <section>
      <HeadTag
        title="Explore Trending Topics: Access the list of trending topics' links for news, photos, and videos on Newstak"
        description="Latest topics to browse: Get here the list of trending topic’s links to browse news, photos, videos at Newstak.
       "
       image={`https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/topics"}
      />
      <GTMScript />
      <BreadcrumbSchema breadcrumbList={topicListData?.category_detail} />

      <Breadcrumb
        breadcrumbList={[
          {
            title: "टॉपिक",
            canonical_url: "/topics",
            icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/topic.svg",
          },
        ]}
      />
      {/* <VDOAdsScript /> */}
      <h1 style={{ display: "none" }}>Latest Topic to browse</h1>
      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />

        <header className="flex justify-between items-center my-3">
          <div className="flex">
            <SVG
              className="text-primary w-6 h-6 inline mr-2 min-w-[29px]"
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/topic.svg"
            />

            <div className="text-primary font-bold text-2xl">
              <h1>टॉपिक</h1>
            </div>
          </div>
        </header>

        <div className="flex space-x-1 overflow-y-auto my-4 text-center">
          <div
            onClick={() => handleTabChange(-1)}
            className={`px-2 whitespace-nowrap py-2 rounded-lg text-sm font-small focus:outline-none transition-colors cursor-pointer ${activeTab === -1
              ? "bg-primary text-white"
              : "bg-white-200 border border-solid border-gray-200 text-gray-800 hover:bg-gray-300"
              }`}
          >
            All
          </div>
          {topicListData?.content?.map(
            (tab, index) =>
              !excludeTopicCategory.includes(tab?.name) &&
              topicListData?.content?.[index]?.list?.length !== 0 && (
                <div
                  key={index}
                  onClick={() => {
                    handleTabChange(index);
                  }}
                  className={`px-2 whitespace-nowrap py-2 rounded-lg text-sm font-small focus:outline-none transition-colors cursor-pointer ${activeTab === index
                    ? "bg-primary text-white"
                    : "bg-white-200 border border-solid border-gray-200 text-gray-800 hover:bg-gray-300"
                    }`}
                >
                  {tab?.name}
                </div>
              )
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4">
          {activeTab === -1 &&
            allTopicsData?.map((item, index) => (
              <Fragment key={index}>
                <TopicCard item={item} isLCP={index === 0 ? true : false} />
                {/* Check if the index is 2, which is the last card of the first row */}
                {/* {index === adIndex && (
                  <div className="col-span-2 sm:col-span-4">
                    <VDOAdSlot />
                  </div>
                )} */}
              </Fragment>
            ))}
          {activeTab !== -1 &&
            topicListData &&
            topicListData?.content?.[activeTab]?.list?.map((item, index) => (
              <Fragment key={index}>
                <TopicCard item={item} isLCP={index === 0 ? true : false} />

                {/* Check if the index is 2, which is the last card of the first row */}
                {/* {index === adIndex && (
                  <div className="col-span-2 sm:col-span-4">
                    <VDOAdSlot />
                  </div>
                )} */}
              </Fragment>
            ))}

          {activeTab !== -1 &&
            topicListData &&
            topicListData?.content?.[activeTab]?.list?.length === 0 && (
              <div className="col-span-2 sm:col-span-4 mt-4">
                <NoData message="No Topics yet" />
              </div>
            )}
        </div>

        {scrolled && <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />}
        {scrolled && <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />}
      </section>
    </section>
  );
};

export default TopicList;
